import { NotEqualsError } from '../../validation/errors/not-equals-error'
import { type FieldValidation } from '../../validation/protocols/field-validation'

export class CompareValidation implements FieldValidation {
  readonly field: string

  constructor (field: string) {
    this.field = field
  }

  validate (value: string, secondValue?: string): Error | null {
    if (value !== secondValue) return new NotEqualsError()
    return null
  }
}
